import { render, staticRenderFns } from "./MultiBarchart.vue?vue&type=template&id=6c1409b3&scoped=true&"
import script from "./MultiBarchart.vue?vue&type=script&lang=js&"
export * from "./MultiBarchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1409b3",
  null
  
)

export default component.exports